exports.createAddItemSystem = ({$scope}) => {
    const onAddSample = () =>
        $scope.get_required_samples($scope.selected_element);

    return {
        handleRequestAddMood: (mood) => {
            if ($scope.selected_soundset.user_can_edit_soundset)
               $scope.copy_mood_to_soundset(mood, $scope.selected_soundset);
            else
                console.warn("Can not add to this SoundSet. This should not have happened, is search state stale?");
        },
        handleRequestAddElement: (element) => {
            if ($scope.selected_soundset.user_can_edit_soundset)
               $scope.add_element_to(element, $scope.selected_soundset, $scope.selected_mood, false);
            else
               console.warn("Can not add to this SoundSet. This should not have happened, is search state stale?");
        },
        handleRequestAddSample: (sample) =>
            $scope.check_attribution(sample, onAddSample),
    }
}


// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/addItemSystem.js